import React from 'react';
import parse, { domToReact } from "html-react-parser"

export const replace = (node) => {
  if (node.name === 'a') {
    return (
      <a {...node.attribs} rel="noreferrer" >
        { domToReact(node.children) }
      </a>
    )
  }
}

export const kiyakucss = `<style>
.kiyakubody {
  margin: 0;
  padding: 0;
}
@media only screen {
  .kiyakubody {
    margin: 2em auto;
    max-width: 900px;
    color: rgb(55, 53, 47);
  }
}

.kiyakubody {
  line-height: 1.5;
  white-space: pre-wrap;
}

a,
a.visited {
  color: inherit;
  text-decoration: underline;
}

h1,
h2,
h3 {
  letter-spacing: -0.01em;
  line-height: 1.2;
  font-weight: 600;
  margin-bottom: 0;
}

.page-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 0.75em;
}

h1 {
  font-size: 1.875rem;
  margin-top: 1.875rem;
}

h2 {
  font-size: 1.5rem;
  margin-top: 1.5rem;
}

h3 {
  font-size: 1.25rem;
  margin-top: 1.25rem;
}

.source {
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 1.5em;
  word-break: break-all;
}

.callout {
  border-radius: 3px;
  padding: 1rem;
}

figure {
  margin: 1.25em 0;
  page-break-inside: avoid;
}

figcaption {
  opacity: 0.5;
  font-size: 85%;
  margin-top: 0.5em;
}

mark {
  background-color: transparent;
}

.indented {
  padding-left: 1.5em;
}

hr {
  background: transparent;
  display: block;
  width: 100%;
  height: 1px;
  visibility: visible;
  border: none;
  border-bottom: 1px solid rgba(55, 53, 47, 0.09);
}

img {
  max-width: 100%;
}

@media only print {
  img {
    max-height: 100vh;
    object-fit: contain;
  }
}

@page {
  margin: 1in;
}

.collection-content {
  font-size: 0.875rem;
}

.column-list {
  display: flex;
  justify-content: space-between;
}

.column {
  padding: 0 1em;
}

.column:first-child {
  padding-left: 0;
}

.column:last-child {
  padding-right: 0;
}

.table_of_contents-item {
  display: block;
  font-size: 0.875rem;
  line-height: 1.3;
  padding: 0.125rem;
}

.table_of_contents-indent-1 {
  margin-left: 1.5rem;
}

.table_of_contents-indent-2 {
  margin-left: 3rem;
}

.table_of_contents-indent-3 {
  margin-left: 4.5rem;
}

.table_of_contents-link {
  text-decoration: none;
  opacity: 0.7;
  border-bottom: 1px solid rgba(55, 53, 47, 0.18);
}

table,
th,
td {
  border: 1px solid rgba(55, 53, 47, 0.09);
  border-collapse: collapse;
}

table {
  border-left: none;
  border-right: none;
}

th,
td {
  font-weight: normal;
  padding: 0.25em 0.5em;
  line-height: 1.5;
  min-height: 1.5em;
  text-align: left;
}

th {
  color: rgba(55, 53, 47, 0.6);
}

ol,
ul {
  margin: 0;
  margin-block-start: 0.6em;
  margin-block-end: 0.6em;
}

li > ol:first-child,
li > ul:first-child {
  margin-block-start: 0.6em;
}

ul > li {
  list-style: disc;
}

ul.to-do-list {
  text-indent: -1.7em;
}

ul.to-do-list > li {
  list-style: none;
}

.to-do-children-checked {
  text-decoration: line-through;
  opacity: 0.375;
}

ul.toggle > li {
  list-style: none;
}

ul {
  padding-inline-start: 1.7em;
}

ul > li {
  padding-left: 0.1em;
}

ol {
  padding-inline-start: 1.6em;
}

ol > li {
  padding-left: 0.2em;
}

.mono ol {
  padding-inline-start: 2em;
}

.mono ol > li {
  text-indent: -0.4em;
}

.toggle {
  padding-inline-start: 0em;
  list-style-type: none;
}

/* Indent toggle children */
.toggle > li > details {
  padding-left: 1.7em;
}

.toggle > li > details > summary {
  margin-left: -1.1em;
}

.selected-value {
  display: inline-block;
  padding: 0 0.5em;
  background: rgba(206, 205, 202, 0.5);
  border-radius: 3px;
  margin-right: 0.5em;
  margin-top: 0.3em;
  margin-bottom: 0.3em;
  white-space: nowrap;
}

.collection-title {
  display: inline-block;
  margin-right: 1em;
}

time {
  opacity: 0.5;
}

.icon {
  display: inline-block;
  max-width: 1.2em;
  max-height: 1.2em;
  text-decoration: none;
  vertical-align: text-bottom;
  margin-right: 0.5em;
}

img.icon {
  border-radius: 3px;
}

.user-icon {
  width: 1.5em;
  height: 1.5em;
  border-radius: 100%;
  margin-right: 0.5rem;
}

.user-icon-inner {
  font-size: 0.8em;
}

.text-icon {
  border: 1px solid #000;
  text-align: center;
}

.page-cover-image {
  display: block;
  object-fit: cover;
  width: 100%;
  height: 30vh;
}

.page-header-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.page-header-icon-with-cover {
  margin-top: -0.72em;
  margin-left: 0.07em;
}

.page-header-icon img {
  border-radius: 3px;
}

.link-to-page {
  margin: 1em 0;
  padding: 0;
  border: none;
  font-weight: 500;
}

p {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  text-align: left;
}

.image {
  border: none;
  margin: 1.5em 0;
  padding: 0;
  border-radius: 0;
  text-align: center;
}

.code,
code {
  background: rgba(135, 131, 120, 0.15);
  border-radius: 3px;
  padding: 0.2em 0.4em;
  border-radius: 3px;
  font-size: 85%;
  tab-size: 2;
}

code {
  color: #eb5757;
}

.code {
  padding: 1.5em 1em;
}

.code-wrap {
  white-space: pre-wrap;
  word-break: break-all;
}

.code > code {
  background: none;
  padding: 0;
  font-size: 100%;
  color: inherit;
}

blockquote {
  font-size: 1.25em;
  margin: 1em 0;
  padding-left: 1em;
  border-left: 3px solid rgb(55, 53, 47);
}
  
.sans { font-family: ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol"; }
.code { font-family: "SFMono-Regular", Menlo, Consolas, "PT Mono", "Liberation Mono", Courier, monospace; }
.serif { font-family: Lyon-Text, Georgia, ui-serif, serif; }
.mono { font-family: iawriter-mono, Nitti, Menlo, Courier, monospace; }
</style>`;
const Kiyaku = () => {
  const html = kiyakucss + `<article id="e6ba40c3-0de0-4375-812d-dc3d104aeed9" class="page sans kiyakubody"><header><h1 class="page-title">SelectBook 利用規約</h1></header><div class="page-body"><p id="317f36a9-2bf4-406a-a0c4-bfc8ed14289c" class="">
  </p><p id="84e04695-10b0-48a3-9200-0ba9d6fe1104" class=""><strong>　本利用規約（以下「本規約」といいます）には、本サービスの提供条件および株式会社セレクト（以下「当社」といいます）とユーザーの皆様との間の権利義務関係が定められています。本サービスの利用に際しては、本規約の全文をお読みいただいたうえで、本規約に同意いただく必要があります。</strong></p><p id="57fb1c96-9dbe-448f-ad57-c7e6661a6add" class="">
  </p><p id="16583bc0-d48c-43e0-b329-d7754da66c9b" class=""><strong><strong>第1条（適用）
  1. 本規約は、本サービスの提供条件および本サービスの利用に関する当社とユーザーとの間の権利義務関係を定めることを目的とし、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されます。
  2. 当社が当社ウェブサイト上で掲載する本サービス利用に関するルールは、本規約の一部を構成するものとします。
  3. 本規約の内容と、前項のルールその他の本規約外における本サービスの説明等とが異なる場合は、本規約の規定が優先して適用されるものとします。
  4. ユーザーが本サービスにアクセスし、本サービスを利用することで、ユーザーは本サービスを本規約に従い利用することに同意したものとみなし、サービス利用契約がユーザーと当社の間に成立します。</strong></strong></p><p id="429c537e-e9cc-4550-8e80-70d079266173" class=""><strong><strong>第2条（定義）
  1. 「サービス利用契約」とは、本規約を契約条件として当社とユーザーの間で締結される、本サービスの利用契約を意味します。
  2. 「知的財産権」とは、著作権、特許権、実用新案権、意匠権、商標権その他の知的財産権（それらの権利を取得し、またはそれらの権利につき登録等を出願する権利を含みます）を意味します。
  3. 「ユーザー」とは、本サービスのユーザーとしての法人または個人を意味します。
  8. 「本サービス」とは、当社が提供する「SelectBook」という名称のサービス（理由の如何を問わずサービスの名称または内容が変更された場合は、当該変更後のサービスを含みます。）を意味します。
  </strong></strong></p><p id="ba488310-0c82-41cb-9ffd-480eecac168e" class=""><strong><strong>第4条（アカウント登録）
  1. 利用者は、商品紹介ページの閲覧、検索など、本サービスの一部をアカウント登録せずに利用することができます。
  2. アカウント登録が必要となるサービスの利用を希望するユーザー（以下「登録希望者」といいます）は、当社の定める一定の情報（以下「登録事項」といいます）を当社の定める方法で当社に提供することにより、アカウント登録の申請をすることができます。
  3. 当社は、当社の基準に従って、第2項に基づいて登録申請を行った登録希望者（以下「登録申請者」といいます）の登録の可否を判断し、当社が登録を認める場合にはその旨を登録申請者に通知します。登録申請者のアカウント登録は、当社が本項の通知を行ったことをもって完了したものとします。
  4. 当社は、登録申請者が、以下の各号のいずれかの事由に該当する場合は、アカウント登録および再登録を拒否することがあり、またその理由について一切開示義務を負いません。
      1. 当社に提供した登録事項の全部または一部につき虚偽、誤記または記載漏れがあった場合
      2. 反社会的勢力等（暴力団、暴力団員、右翼団体、反社会的勢力、その他これに準ずる者を意味します。以下同じ）である、または資金提供その他を通じて反社会的勢力等の維持、運営もしくは経営に協力もしくは関与する等反社会的勢力等との何らかの交流もしくは関与を行っていると当社が判断した場合
      3. その他、登録を適当でないと当社が判断した場合</strong></strong></p><p id="fef5bf98-f29a-4c56-a5c1-c85eb984fda1" class=""><strong><strong>第5条（登録事項の変更）
  ユーザーは、登録事項に変更があった場合、当社の定める方法により当該変更事項を遅滞なく当社に通知するものとします。</strong></strong></p><p id="ac386b52-1e17-4d4c-8895-7f11d6abdf66" class=""><strong><strong>第6条（パスワードおよびユーザーIDの管理）
  1. ユーザーは、自己の責任において、本サービスに関するパスワードおよびユーザーID（当社が連携先として指定するTwitter等の外部サービス（以下「外部サービス」といいます）のパスワードおよびユーザーIDを含みます）を適切に管理および保管するものとし、これを第三者に利用させ、または貸与、譲渡、名義変更、売買等をしてはならないものとします。
  2. パスワードまたはユーザーIDの管理不十分、使用上の過誤、第三者の使用等による場合でも、当社はユーザーによる使用とみなします。
  3. 本条に関連してユーザーに生じた損害に関する一切の責任は、ユーザー自身が負うものとします。</strong></strong></p><p id="c3b64d0c-603b-4b53-960e-723cfb194674" class=""><strong><strong>第7条（禁止事項）
  ユーザーは、本サービスの利用にあたり、以下の各号のいずれかに該当する行為または該当すると当社が判断する行為をしてはなりません。
  1. 法令に違反する行為または犯罪行為に関連する行為
  2. 当社、本サービスの他の利用者またはその他の第三者に対する詐欺または脅迫行為
  3. 公序良俗に反する行為
  4. 当社、本サービスの他の利用者またはその他の第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利または利益を侵害する行為
  5. 本サービスを通じ、以下に該当し、または該当すると当社が判断する情報を投稿し、または当社もしくは本サービスの他の利用者に送信すること
      ◦ 過度に暴力的または残虐な表現を含む情報
      ◦ コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報
      ◦ 当社、本サービスの他の利用者またはその他の第三者の名誉または信用を毀損する表現を含む情報
      ◦ 過度にわいせつ、性的な興味関心を引かせる、性的な内容を連想させるなどの表現を含む情報
      ◦ 差別を助長する表現を含む情報
      ◦ 自殺、自傷行為を助長する表現を含む情報
      ◦ 薬物の不適切な利用を助長する表現を含む情報
      ◦ 反社会的な表現を含む情報
      ◦ チェーンメール等の第三者への情報の拡散を求める情報
      ◦ 他人に不快感を与える表現を含む情報
  6. 本サービスのネットワークまたはシステム等に過度な負荷をかける行為
  7. 当社が提供するソフトウェアその他のシステムに対するリバースエンジニアリングその他の解析行為
  8. 本サービスの運営を妨害するおそれのある行為
  9. 当社のネットワークまたはシステム等への不正アクセス
  10. 第三者に成りすます行為
  11. 本サービスの他の利用者のIDまたはパスワードを利用する行為
  12. 当社が事前に許諾しない本サービス上での宣伝、広告、勧誘、または営業行為
  13. 本サービスの他の利用者の情報の収集
  14. 当社、本サービスの他の利用者またはその他の第三者に不利益、損害、不快感を与える行為
  15. 反社会的勢力等への利益供与
  16. 面識のない異性との出会いを目的とした行為
  17. 外部の掲示板や商用利用禁止のSNSにおいて、商品紹介ページのリンクを掲載する行為
  18. 外部サービスへの勧誘行為
  19. スクリプトなどで機械的に自己または第三者が投稿した商品紹介ページに評価またはコメントなどを行う行為
  20. 本サービスと同種、類似のサービスを行う行為
  21. その他、当社が不適切と判断する行</strong></strong></p><p id="8e8e6a23-16bf-4464-a2f5-abb6f8f60712" class=""><strong><strong>第10条（権利帰属）
  1. 当社ウェブサイトおよび本サービスに関する知的財産権は全て当社または当社にライセンスを許諾している者に帰属しており、本規約に基づく本サービスの利用許諾は、当社ウェブサイトまたは本サービスに関する当社または当社にライセンスを許諾している者の知的財産権の使用許諾を意味するものではありません。
  </strong></strong></p><p id="2ea36d84-363b-48d6-b5fd-c7f312c60471" class=""><strong><strong>第11条（本サービスの停止等）
  当社は、以下のいずれかに該当する場合には、ユーザーに事前に通知することなく、本サービスの全部または一部の提供を停止または中断することができるものとします。
  1. 本サービスに係るコンピューター・システムの点検または保守作業を緊急に行う場合
  2. コンピューター、通信回線等の障害、誤操作、過度なアクセスの集中、不正アクセス、ハッキング等により本サービスの運営ができなくなった場合
  3. 地震、落雷、火災、風水害、停電、天災地変などの不可抗力により本サービスの運営ができなくなった場合
  4. その他、当社が停止または中断を必要と判断した場合</strong></strong></p><p id="a959f86a-dbe4-492f-8436-4e6c80ffe623" class=""><strong><strong>第12条（本サービスの内容の変更、終了）
  1. 当社は、当社の都合により、本サービスの内容を変更し、または提供を終了することができます。
  2. 当社が本サービスの提供を終了する場合、当社はユーザーに事前に通知するものとします。</strong></strong></p><p id="1ab0048e-733b-49ca-960c-148e2ac57cba" class=""><strong><strong>第163条（秘密保持）
  ユーザーは、本サービスに関連して当社がユーザーに対して秘密に取扱うことを求めて開示した非公知の情報について、当社の事前の書面による承諾がある場合を除き、秘密に取扱うものとします。</strong></strong></p><p id="c6919818-938a-4521-a569-72d23257e0ce" class=""><strong><strong>第14条（利用者情報の取扱い）
  1. 当社によるユーザーの利用者情報の取扱いについては、別途当社プライバシーポリシーの定めによるものとし、ユーザーはこのプライバシーポリシーに従って当社がユーザーの利用者情報を取扱うことについて同意するものとします。
  2. 当社は、ユーザーが当社に提供した情報、データ等を、個人を特定できない形での統計的な情報として、当社の裁量で、利用および公開することができるものとし、ユーザーはこれに異議を唱えないものとします。</strong></strong></p><p id="7cff33fa-3f0d-48d3-8e7f-e5e3f0c37885" class=""><strong><strong>第15条（本規約等の変更）
  当社は、当社が必要と認めた場合は、本規約を変更できるものとします。本規約を変更する場合、変更後の本規約の施行時期および内容を当社ウェブサイト上での掲示その他の適切な方法により周知し、またはユーザーに通知します。ただし、法令上ユーザーの同意が必要となるような内容の変更の場合は、当社所定の方法でユーザーの同意を得るものとします。</strong></strong></p><p id="326e2c04-3970-47cf-9c7d-ef4bd88d4e46" class=""><strong><strong>第16条（連絡／通知）
  1. 本サービスに関する問い合わせその他ユーザーから当社に対する連絡または通知、および本規約の変更に関する通知その他当社からユーザーに対する連絡または通知は、当社の定める方法で行うものとします。
  2. 当社が登録事項に含まれるメールアドレスその他の連絡先に連絡または通知を行った場合、ユーザーは当該連絡または通知を受領したものとみなします。</strong></strong></p><p id="1486b3c2-7fe0-48bb-855c-c12abc9ff916" class="">
  </p><p id="7308100d-7b4c-4ad2-90e3-da5afddb2629" class=""><strong>【2021年8月21日制定】</strong></p><p id="e8d53d36-afee-40e6-8f8a-5d755a0aefe9" class="">
  </p></div></article>`
  return (
    <div>
      <section>
        <p>{ parse(html, { replace }) }</p>
      </section>
    </div>
  );
}

export default Kiyaku;